import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  getInterpreterProvider,
  setURL,
} from "../providers/InterpreterProvider";

const useSetInterpreterStatus = () => {
  const interpreterSessionId = useSelector(
    (state) => state.config.interpreterSessionId?.value
  );
  const partcipantList = useSelector((state) => state.call?.participants?.list);

  const interpreterProvider = useRef(null);

  const gcpServices = useSelector((state) => state.config.listOfGCPServices);

  const getInterpreterDetails = async () => {
    let interperter = null;
    for (let particpant of partcipantList) {
      if (particpant.isLocal) {
        interperter = particpant;
      }
    }
    return interperter;
  };

  const interpreterJoined = async () => {
    const interpreter = await getInterpreterDetails();
    if (interpreter === null) {
      return null;
    }
    const resp = await interpreterProvider.current.interpreterJoin({
      sessionId: interpreterSessionId,
      id: interpreter.userId,
      name: interpreter.name,
    });
    return resp;
  };

  const interpreterLeft = async () => {
    if (interpreterSessionId && interpreterProvider.current) {
      const resp = await interpreterProvider.current.interpreterLeft(
        interpreterSessionId
      );
      return resp;
    }
  };

  useEffect(() => {
    if (
      !gcpServices?.interpreterService?.url ||
      !gcpServices?.interpreterService?.isServiceAvailable
    ) {
      console.error("listOfGCPServices interpreter configuration is wrong");
    } else {
      setURL(gcpServices?.interpreterService?.url);
      interpreterProvider.current = getInterpreterProvider();
    }
    // eslint-disable-next-line
  }, []);

  return {
    interpreterLeft: interpreterLeft,
    interpreterJoined: interpreterJoined,
  };
};
export default useSetInterpreterStatus;
